import { sortNotificationsByPriority, isUnread } from "../model/utils";
export class NotificationService {
    static filterNotifications(notifications, filters) {
        let filtered = [...notifications];
        if (filters.type) {
            filtered = filtered.filter((n) => n.type === filters.type);
        }
        if (filters.read !== undefined) {
            filtered = filtered.filter((n) => (filters.read ? !isUnread(n) : isUnread(n)));
        }
        if (filters.dateRange) {
            const { start, end } = filters.dateRange;
            filtered = filtered.filter((n) => {
                const createdAt = new Date(n.createdAt);
                return createdAt >= start && createdAt <= end;
            });
        }
        return sortNotificationsByPriority(filtered);
    }
    static getUnreadCount(notifications) {
        return notifications.filter(isUnread).length;
    }
    static getNotificationsByType(notifications, type) {
        return notifications.filter((n) => n.type === type);
    }
    static markAsReadLocally(notifications, notificationId) {
        return notifications.map((n) => (n.id === notificationId ? { ...n, readAt: new Date().toISOString() } : n));
    }
    static markAllAsReadLocally(notifications) {
        const now = new Date().toISOString();
        return notifications.map((n) => (isUnread(n) ? { ...n, readAt: now } : n));
    }
    static removeNotificationLocally(notifications, notificationId) {
        return notifications.filter((n) => n.id !== notificationId);
    }
    static shouldShowNotificationBadge(notifications) {
        return this.getUnreadCount(notifications) > 0;
    }
    static getNotificationSummary(notifications) {
        const unreadCount = this.getUnreadCount(notifications);
        const totalCount = notifications.length;
        return {
            unreadCount,
            totalCount,
            hasUnread: unreadCount > 0,
            isEmpty: totalCount === 0,
        };
    }
}
